import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { RotationCargoOperation } from 'src/types/ViewModel/Stowage/Rotation/RotationCargoOperation';
import { Tank } from 'src/types/ViewModel/Vessel/Tank';
import { Violation } from 'src/types/ViewModel/Stowage/Violation/Violation';
import { CargoTankDetails } from 'src/types/ViewModel/Stowage/CargoTankDetails';

type StowageSelectionContextType = {
    selectedTanks: Tank[];
    setSelectedTanks: (selectedTanks: Tank[]) => void;
    selectedCargoOperation: RotationCargoOperation | null;
    setSelectedCargoOperation: (cargoOperation: RotationCargoOperation | null) => void;
    tooltipPosition: { x: number; y: number };
    setTooltipPosition: (num: { x: number; y: number }) => void;
    selectedTab: string;
    setSelectedTab: (selectedTab: string) => void;
    selectedViolations: Violation[] | null;
    setSelectedViolations: (violations: Violation[] | null) => void;
    selectedViolationListFilter: string;
    setSelectedViolationListFilter: (selectedViolationListFilter: string) => void;
    selectedViolationListStatusFilter: string;
    setSelectedViolationListStatusFilter: (selectedViolationListStatusFilter: string) => void;
    filteredViolations: Violation[] | null;
    setFilteredViolations: (filteredViolations: Violation[] | null) => void;
    hoveredTank: Tank | null;
    setHoveredTank: (tank: Tank | null) => void;
    cargoDetailsInfo: CargoTankDetails | null;
    setCargoDetailsInfo: (details: CargoTankDetails | null) => void;
    filterTanksForReport: boolean;
    setFilterTanksForReport: (filterTanksForReport: boolean) => void;
};

export const StowageSelectionContext = React.createContext<StowageSelectionContextType>(undefined!);

export const StowageSelectionProvider = ({ children }: ContextProps) => {
    const [selectedTanks, setSelectedTanks] = useState<Tank[]>([]);
    const [selectedCargoOperation, setSelectedCargoOperation] = useState<RotationCargoOperation | null>(null);
    const [tooltipPosition, setTooltipPosition] = useState<{ x: number; y: number }>({ x: 0, y: 0 });
    const [selectedTab, setSelectedTab] = useState<string>('Operation List');
    const [selectedViolations, setSelectedViolations] = useState<Violation[] | null>(null);
    const [selectedViolationListFilter, setSelectedViolationListFilter] = useState<string>('Selected call');
    const [selectedViolationListStatusFilter, setSelectedViolationListStatusFilter] = useState<string>('All statuses');
    const [filteredViolations, setFilteredViolations] = useState<Violation[] | null>(null);
    const [hoveredTank, setHoveredTank] = useState<Tank | null>(null);
    const [cargoDetailsInfo, setCargoDetailsInfo] = useState<CargoTankDetails | null>(null);
    const [filterTanksForReport, setFilterTanksForReport] = useState<boolean>(false);

    return (
        <StowageSelectionContext.Provider
            value={{
                selectedTanks,
                setSelectedTanks,
                selectedCargoOperation,
                setSelectedCargoOperation,
                tooltipPosition,
                setTooltipPosition,
                selectedTab,
                setSelectedTab,
                selectedViolations,
                setSelectedViolations,
                selectedViolationListFilter,
                setSelectedViolationListFilter,
                selectedViolationListStatusFilter,
                setSelectedViolationListStatusFilter,
                filteredViolations,
                setFilteredViolations,
                hoveredTank,
                setHoveredTank,
                cargoDetailsInfo,
                setCargoDetailsInfo,
                filterTanksForReport,
                setFilterTanksForReport,
            }}
        >
            {children}
        </StowageSelectionContext.Provider>
    );
};

export const useStowageSelectionStore = () => useContext(StowageSelectionContext);
